module.exports = __webpack_public_path__ + "img/waiting-on-photo@3x.6a9bac03.png";